<template>
  <BittsModalTwo
    title="Talk to Sales"
    class="talk-to-sales-modal"
    secondary-button-text="Close"
    :show-primary-button="false"
    :use-mask-to-close="true"
    :width="900"
    :no-padding="true"
    background-color="rgb(250, 250, 251)"
    @closed="emit('close-modal')"
    @action="emit('close-modal')"
  >
    <iframe
      width="100%"
      height="506"
      :src="talkToSalesUrl"
      title="Talk to sales"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerpolicy="strict-origin-when-cross-origin"
    ></iframe>
  </BittsModalTwo>
</template>
<script setup lang="ts">
import { BittsModalTwo } from '@crossbeam/bitts';

import { computed } from 'vue';

import useAuth from '@/composables/useAuth';

const emit = defineEmits<(e: 'close-modal') => void>();

const { currentUser } = useAuth();

const talkToSalesUrl = computed(() => {
  return `https://crossbeam.chilipiper.com/concierge-router/link/cb-talk-to-sales-router---in-app?email=${currentUser.value.email}`;
});
</script>
<style scoped lang="pcss">
.talk-to-sales-modal {
  @apply !z-[9999];
}
</style>
